
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'abs',
  standalone: true,
})
export class AbsValuePipe implements PipeTransform {
  transform(value: number): number {
    return Math.abs(value);
  }
}
